
import { ButtonSizes, Icon, Modal, TextLink } from '@repo/ui';
import { LINKS } from 'assets';
import hsaFsaImage from 'assets/images/hsa-fsa-eligible.svg';
import { LinkButton, Typography } from 'components';

import { urls } from '@repo/app-constants';
import styles from './VideoResources.module.scss';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UpgradeModal = ({ isOpen, onClose }: UpgradeModalProps) => {
  const upgradeLink = urls.MEMBERSHIP;

  return (
    <Modal isOpen={isOpen} onClose={onClose} showFloatingX>
      <div className='flex flex-column gap-4 align-items-center mt-2 mb-3'>
        <Typography variant='heading-2xl'>Join Tiny+</Typography>
        <div className={styles.stars}>
          <Icon name='starFilled' size='m' />
          <Icon name='starFilled' size='m' />
          <Icon name='starFilled' size='m' />
          <Icon name='starFilled' size='m' />
          <Icon name='starFilled' size='m' />
        </div>
        <div className={styles.modalContent}>
          <div className='flex align-items-center justify-content-between gap-1'>
            <Typography variant='heading-m'>Yearly membership</Typography>
            <Typography variant='label'>{`$33.25 / mo`}</Typography>
          </div>
          <div className={styles.modalItem}>
            <div className='green'>
              <Icon name='check' />
            </div>
            <Typography variant='heading-s'>{`Get 2 kits for $399 (regularly $498) + 1 coaching session included`}</Typography>
          </div>
          <div className={styles.modalItem}>
            <div className='green'>
              <Icon name='check' />
            </div>
            <Typography variant='heading-s'>{`Measure changes in diet, supplements, and lifestyle`}</Typography>
          </div>
          <div className={styles.modalItem}>
            <div className='green'>
              <Icon name='check' />
            </div>
            <Typography variant='heading-s'>{`Members-only resources & discounts`}</Typography>
          </div>
          <div className={styles.line}></div>
          <div className='flex align-items-center justify-content-between'>
            <div className={styles.hsaFsa}>
              <img src={hsaFsaImage} alt='HSA/FSA eligible' />
            </div>
            <Typography variant='label'>{`12 months - $399`}</Typography>
          </div>
        </div>
        <LinkButton
          color='purple'
          size={ButtonSizes.M}
          href={upgradeLink}
          external
        >
          Upgrade
        </LinkButton>
        <TextLink label='Terms of Service' to={LINKS.termsOfService} />
      </div>
    </Modal>
  );
};

export default UpgradeModal;
